import { useContext } from 'react';

import { ExperimentContext } from './ExperimentProvider';

export type Experiment =
  | 'Question_Section_Heading'
  | 'Custom_Questions'
  | 'Selection_Type_Toggle'
  | 'Show_Certsy_Verifiable'
  | 'Search_Survey'
  | 'Filter_Awareness'
  | 'Improve_Selection_Experience_New'
  | 'Improve_Selection_Experience_Control'
  | 'Industry_Bundling'
  | 'GraphQL_Search'
  | 'Verify_Boost';

export const useExperiment = (experimentName: Experiment): boolean => {
  const experimentContext = useContext(ExperimentContext);
  return experimentContext.includes(experimentName);
};
